export default __webpack_public_path__ + "static/media/B02.241d5cdf.png";